<jhi-bary-card [titleKey]="title" *ngIf="transportForm">
  <form autocomplete="off" body>
    <div class="row">
      <div class="col-12">
        <jhi-date-picker-form
          [id]="'date'"
          [isUpdate]="isUpdate"
          [options]="options"
          [transporter]="transporter"
          [transportForm]="transportForm"
          [transportConfiguration]="transportConfiguration"
        ></jhi-date-picker-form>
      </div>
    </div>
    <div *ngIf="offerSelected?.flexibilityDeadline && labelFlexibilityDeliveryDate" class="alert alert-info mt-3">
      {{ labelFlexibilityDeliveryDate }}
    </div>
    <div class="row mt-2" *ngIf="transportConfiguration?.commentsAllowed">
      <div class="col-12">
        <jhi-bary-collapse [withArrow]="false" [label]="'Ajouter un commentaire'">
          <jhi-bary-input-textarea
            [id]="switchCase('pickupComments', 'deliveryComment')"
            [control]="switchCase(transportForm.controls.pickupComments, transportForm.controls.deliveryComments)"
            [label]="'LABEL_COMMENT' | translate"
            [maxLength]="200"
            [rows]="1"
          ></jhi-bary-input-textarea>
        </jhi-bary-collapse>
      </div>
    </div>
  </form>
</jhi-bary-card>
